import { Parameter } from "@/components/ModelParameters/AdvancedParameters/ParameterControl";
import { ParameterStore } from "@/components/ModelParameters/store/parameter-store";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { Info } from "lucide-react";
import { useCustomParametersStore } from "./custom-parameters-store";
import { observer, useLocalObservable } from "mobx-react-lite";
import { EmptyPreviewSidebar } from "./Placeholders/EmptyPreviewSidebar";
import { useEffect } from "react";

export const ParametersPreviewSidebar = observer(() => {
  const store = useCustomParametersStore();
  const { currentParameter } = store;

  const previewParameterStore = useLocalObservable(() => {
    return new ParameterStore(currentParameter?.getParameter || {});
  });

  useEffect(() => {
    if (!currentParameter?.getParameter) {
      return;
    }

    previewParameterStore.updateParameter(currentParameter?.getParameter);
  }, [currentParameter?.getParameter, previewParameterStore]);

  return (
    <>
      <div className="mb-4 flex items-center gap-2">
        <h1 className="text-lg font-medium">Parameter Preview</h1>
        <BasicTooltip content="Interacting with the parameter will not update its settings.">
          <Info className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
        </BasicTooltip>
      </div>
      <div className="flex h-full items-center justify-center">
        {currentParameter ? (
          <div className="flex h-full w-full items-center justify-center rounded-md border border-gray-300 bg-gray-50 p-8 shadow-inner">
            <Parameter parameter={previewParameterStore} />
          </div>
        ) : (
          <EmptyPreviewSidebar />
        )}
      </div>
    </>
  );
});
